import { h, Component } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import Button from '../../control-components/ui-components/Button'
import axios from 'axios'
import Tooltip from '../../control-components/ui-components/Tooltip'

interface Props {
  isGuest: boolean
  totalProductUpdatesCountWithoutFilters: number
}

interface ButtonProps {
  isGuest: boolean
}

interface ButtonState {
  isSubscribed: boolean
  isLoading: boolean
}

class SubscribeButton extends Component<ButtonProps, ButtonState> {
  constructor () {
    super()
    this.state = {
      isSubscribed: false,
      isLoading: false
    }
    this.toggleSubscription = this.toggleSubscription.bind(this)
    this.openLoginPopUp = this.openLoginPopUp.bind(this)
  }

  async componentDidMount () {
    const result = await axios.get('/product-updates/subscription')
    const isSubscribed = result.data
    this.setState({ isSubscribed })
  }

  openLoginPopUp () {
    const event = new CustomEvent('GuestUserAction')
    window.dispatchEvent(event)
  }

  async toggleSubscription () {
    this.setState({ isLoading: true })
    const isSubscribed = this.state.isSubscribed
    const url = isSubscribed
      ? '/product-updates/unsubscribe'
      : '/product-updates/subscribe'
    try {
      await axios.post(url)
      this.setState({ isSubscribed: !isSubscribed })
    } finally {
      this.setState({ isLoading: false })
    }
  }

  render (props: ButtonProps, state: ButtonState) {
    if (props.isGuest) {
      return <Button toggle onClick={this.openLoginPopUp}><Phrase p='subscribe.to.updates' /></Button>
    }

    return (
      <Tooltip
        customClasses='product-updates_subscribe-btn--message'
        trigger={<Button loading={state.isLoading} toggle toggleActive={state.isSubscribed} onClick={this.toggleSubscription}>
          {state.isSubscribed ? <Phrase p='subscribed.to.updates' /> : <Phrase p='subscribe.to.updates' />}
        </Button>}
        tooltipMessage={<Phrase p='product.updates.subscribe.tooltip' />}
      />
    )
  }
}

const StatisticsBar = ({ isGuest, totalProductUpdatesCountWithoutFilters }: Props) => {
  return (
    <section className='full-width Template-brand-stats custom-stats-bar'>
      <div className='stats-bar p-v qa-stats-bar'>
        <div className='sitewidth'>
          <div className='col'>
            <ul className='list list--stats-bar qa-stats-bar'>
              <li className='list__item'>
                <strong>{totalProductUpdatesCountWithoutFilters}</strong>
                <span><Phrase p='total.product.updates.counter.without.filter' count={{ n: totalProductUpdatesCountWithoutFilters.toString() }} /></span>
              </li>
            </ul>

            <SubscribeButton isGuest={isGuest}>
              <Phrase p='subscribe.to.updates' />
            </SubscribeButton>
          </div>
        </div>
      </div>
    </section>
  )
}
export default StatisticsBar
